<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Export Employee'">
      <div class="data">
        <div
          *ngIf="isLoading"
          style="margin-top: 200px; padding-bottom: 500px"
          class="spinner"
        >
          <mat-spinner></mat-spinner>
        </div>
        <div>
          <button
            mat-raised-button
            color="primary"
            (click)="print()"
            style="margin: 10px"
          >
            Print
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="exportexcel()"
            style="margin: 10px"
          >
            Export
          </button>
        </div>
        <!-- <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select
              [(ngModel)]="dept_code"
              (selectionChange)="dept($event)"
              matNativeControl
            >
              <mat-option *ngFor="let dept of depts" [value]="dept.id">
                {{ dept.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Sub Department</mat-label>
            <mat-select
              [(ngModel)]="sub_dept_code"
              (selectionChange)="sub($event)"
              matNativeControl
            >
              <mat-option value="0">None </mat-option>
              <mat-option *ngFor="let dept of subDepts" [value]="dept.id">
                {{ dept.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <div>
          <button
            (click)="searchEcounters()"
            style="margin-bottom: 30px; margin-left: 30px"
            mat-raised-button
            color="primary"
          >
            Search
          </button>

        </div> -->
        <div id="print-section">
          <table id="table" *ngIf="!isLoading" style="width: 100%">
            <tr class="back">
              <th>Name</th>
              <th>Title</th>
              <th>Mobile</th>
              <th>Designation</th>
              <th>Email</th>
              <th>Qualification</th>
            </tr>
            <tr class="td" *ngFor="let item of data" style="cursor: pointer">
              <td>{{ item.name }}</td>
              <td>{{ item.title_name }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.Designation }}</td>
              <td>{{ item.email_no }}</td>
              <td>{{ item.qualification }}</td>
            </tr>
          </table>
        </div>
      </div>
    </app-template>
  </div>
</div>
